import { useReducedMotion } from 'framer-motion';

// Reveal once with short travel; reduced-motion users see content immediately.
export default function useReveal(delay = 0) {
  const reduced = useReducedMotion();
  return {
    initial: reduced ? false : { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.12 },
    transition: { duration: reduced ? 0 : 0.45, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] },
  };
}
